<template>
  <div class="row">
    <div class="col-sm-8 offset-sm-2">
      <form action="#" @submit.prevent="searchQuery">
        <div class="input-group">
          <input
            type="text"
            name="address"
            class="form-control welcome__search-input"
            :placeholder="$t('Homepage.SearchForm.placeholder')"
            v-model="query"
            @keydown="handleAutoSuggestKeys"
            @keyup="updateAutoSuggest"
            autofocus>

          <div class="input-group-append">
            <button type="submit" class="btn btn-outline-light">{{ $t('Homepage.SearchForm.submit') }}</button>
          </div>
        </div>
      </form>
      <AutosuggestResults
        v-bind:suggestions="autoSuggestResults"
        v-bind:highlightedSuggestion="highlightedSuggestResult" />
    </div>
  </div>

</template>

<script>
import router from "@/router/index";
import autoSuggest from "@/mixins/autosuggest";
import AutosuggestResults from "./AutosuggestResults";

export default {
  components: { AutosuggestResults },
  mixins: [autoSuggest],
  data() {
    return {
      query: ""
    };
  },
  methods: {
    searchQuery() {
      router.push({
        name: "SearchResults",
        params: { query: this.query }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../assets/variables";

  .welcome__search-input {
    border-color: #fff;
    background-color: rgba(#fff, 0.65);
    transition: background-color 0.5s;
    &:focus {
      background-color: #fff;
    }
  }

  .welcome__search-example {
    font-size: 10px;
    color: rgba(#fff, 0.5);
  }

  .welcome__suggestions {
    background: #fff;
    border: solid 1px #fff;
    border-top: 0;
    border-radius: 0 0 2px 2px;
    color: #212529;
    list-style: none;
    padding: 0;
    position: absolute;
    left: 15px;
    right: 15px;
  }

  .welcome__suggestions li {
    text-align: left;
    padding: 2px 4px;
  }

  .welcome__suggestions .suggestions__hint {
    font-size: 0.8em;
    font-style: italic;
  }

  .result-item {
    list-style: none;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Homepage/SearchForm.vue